import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useFeatureGate } from '@statsig/react-bindings';

import { StatsigFlags } from '../../common/types';

type WidgetVideoProps = {
  productId: string;
};

const WidgetContainer = styled.div`
  display: block;
  max-width: 100%;
  overflow: hidden;
`;

export const WidgetVideo = ({ productId }: WidgetVideoProps) => {
  const isJoinVideoWidgetEnabled = useFeatureGate(StatsigFlags.JOIN_VIDEO).value;
  const [isScriptOnError, setIsScriptOnError] = useState(false);

  useEffect(() => {
    if (!isJoinVideoWidgetEnabled || !productId) {
      return () => null;
    }

    const baseUrl = 'https://darjeeling.my.join-stories.com/widgets/Widget-PDP';

    const script = document.createElement('script');
    script.src = `${baseUrl}/${productId}.js`;
    script.type = 'text/javascript';
    script.setAttribute('data-join-widget-id', 'join-widget-Widget-PDP');
    script.setAttribute('data-join-widget-alias', 'Widget-PDP');

    script.onerror = () => {
      setIsScriptOnError(true);
    };
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [productId, isJoinVideoWidgetEnabled]);

  if (!isJoinVideoWidgetEnabled || isScriptOnError) {
    return null;
  }

  return <WidgetContainer id="join-widget-Widget-PDP" />;
};
